module.exports = __webpack_public_path__ + "static/img/VG.e61bc619.svg";